import * as Yup from "yup";

export default function NumberValidation(min, max) {
  return Yup.number()
    .typeError("Must be a number")
    .integer("Must be a number")
    .integer()
    .min(min, `Must be greater than or equal to ${min}`)
    .max(max, `Must be less than or equal to ${max}`)
    .required("Required");
}
